export default __webpack_public_path__ + "images/logo-bw-solo.png?a1865afa790271806dc4dae4d503692a";